/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types'; 
import { Button, Grid, Modal, Input } from '../../../components/index';
import SelecaoEntidade from '../../relatorios/SelecaoEntidade';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import Masks from '../../../utils/masks'; 
import {
  tipoRegime,
} from '../../../utils/listsSelect';
import {
  validateObject,
} from '../../../utils/requests';

const pemissoesAcaoPrincipal = ['analisar-compensacao-rpps', 'requerer-compensacao-rpps'];

const rowStyle = {
  marginBottom: '10px',
  fontSize: '16px',
};

const VAZIO = '';
const CODIGO_RGPS = '01000';

class ModalDestinacao extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    touched: false,
  });

  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.props.statePrincipal };
    switch (acao) {
      case 'novo':
        return validateObject(this.props.stateDestinatario.validadeCampos);
      case 'revisar-ctc':
        return validateObject(this.props.stateDestinatario.validadeCampos);              
      case 'editar-rascunho':
        return validateObject(this.props.stateDestinatario.validadeCampos);
      default:
        return false;
    }
  }

  handleCancelarAcao = () => {
    this.setState({
      exibirBotaoIncluirInicial: true, //ALTERAR
      tituloBotao: 'adicionar destinatário',
    });
  }

  alteraLista = (lista) => {
    const id = this.props.id;
    this.props.handleChange({ value: lista, isValid: lista.length > 0 }, this.props.determinarNomeListaAtividades());
    if(id === 3){
      this.props.gerenciarDestinacao(lista, 1);
    }
    this.handleClose();
  }

  recuperarNomeDestinatario = (indice) => {
    let retorno = VAZIO;
    if (this.props.statePrincipal.destinacoesTempoCertificado) {
      const listaDestinacoesTempoCertificado = this.props.statePrincipal.destinacoesTempoCertificado;
      if (listaDestinacoesTempoCertificado !== undefined && listaDestinacoesTempoCertificado.length > 0) {
        const indiceNome = listaDestinacoesTempoCertificado.findIndex(d => (d.value === indice));
        if (indiceNome !== -1) {
          retorno = listaDestinacoesTempoCertificado[indiceNome].label;
        }
      }
    }
    return retorno;
  }

  criarTituloModal = () => {
    const { subEstadoFormulario } = { ...this.props.stateDestinatario };
    let tituloOperacao = 'incluir';
    let retorno = VAZIO;

    if (subEstadoFormulario === 'alterar-destinacao') {
      tituloOperacao = 'alterar';
    }

    if (subEstadoFormulario === 'detalhar-destinacao') {
      tituloOperacao = 'alterar';
    }

    retorno = `${tituloOperacao} destinatário`;
    return retorno;
  }

  verificaSeCampoDesabilitado = (name) => {
    const { acao } = { ...this.props.statePrincipal };
    if (['detalhar-ctc', 'detalhar-ctc-invalida'].includes(acao)) {
      return true;
    }
    return false;
  };

  desabilitarSelecaoEntidade = () => {
    return ['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao);
  }

  verificarValorTipoRegime = () => {
    if (['editar-rascunho', 'revisar-ctc', 'novo', 'detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) {
      if ((this.props.stateDestinatario.tipoRegime === null || this.props.stateDestinatario.tipoRegime === '') &&
        (!['incluir-destinacao', 'excluir-destinacao'].includes(this.props.stateDestinatario.subEstadoFormulario))) {
        if (this.props.stateDestinatario.ctcDestinacao.codigoParticipante === CODIGO_RGPS) {
          return 1;
        }
        return 2;
      } else {
        return this.props.stateDestinatario.tipoRegime;
      }      
    }
  }

  modalFooter = () => (
    <React.Fragment>
      {(!['detalhar-ctc', 'detalhar-ctc-invalida'].includes(this.props.statePrincipal.acao)) &&
        <ProtectedItem allowedPermissions={pemissoesAcaoPrincipal}>
          <Button
            disabled={!this.formularioProntoParaEnvio()}
            className="reajustaDireitaBotao"
            title={this.props.stateDestinatario.tituloBotao}
            onClick={ this.props.handleManterDestinacao }
            hint={this.props.stateDestinatario.tituloBotao}
          />
          {(this.props.stateDestinatario.estadoFormulario === 'alterar' ||
            this.props.stateDestinatario.estadoFormulario === 'incluir') &&
            <Button
              className="reajustaDireitaBotao"
              title='cancelar'  
              onClick={this.props.handleCancelarAcao}
              hint='cancelar'
            />
          }
        </ProtectedItem>
      }
    </React.Fragment>
  )

  modalContent = () => (
    <React.Fragment>
      <div className="row" style={rowStyle}>
        <SelecaoEntidade
          handleChange={this.props.handleChange}
          destinatarios={this.props.destinatarios}
          papelUsuarioLogado={null}
          titulo=""
          retirarLinhaSeparadora={true}
          tipoRegime={this.verificarValorTipoRegime()}
          // tipoRegime={this.props.stateDestinatario.tipoRegime}
          tipoEntidade={this.props.stateDestinatario.tipoEntidade}
          uf={this.props.stateDestinatario.uf}
          participante={this.props.stateDestinatario.codigoParticipante}
          nomeAtributoComboboxRegime="tipoRegime"
          nomeAtributoComboboxParticipante="codigoParticipante"
          nomeAtributoComboboxTipoEntidade="tipoEntidade"
          nomeAtributoComboboxUF="uf"
          listaTiposRegimes={tipoRegime}
          labelComboboxParticipante="Participante"
          desabilitar={this.desabilitarSelecaoEntidade()}
        />
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              disabled={this.verificaSeCampoDesabilitado('cnpj')}
              // required
              label="CNPJ"
              mask={Masks.cnpj}
              onChange={e => this.props.handleChange(e, 'cnpj')}
              value={this.props.stateDestinatario.ctcDestinacao.cnpj}
              integer
              exibirBotao={this.props.statePrincipal.acao === 'novo' ||
              this.props.statePrincipal.acao === 'editar-rascunho' ||
              this.props.statePrincipal.acao === 'revisar-ctc'}
              onClickDoBotao={() => this.props.handleSearchCnpjButton('nomeOrgao', this.props.stateDestinatario.ctcDestinacao.cnpj)}
              hintDoBotao="Pesquisar cnpj do orgão destinatário"
              iconeDoBotao="ico-doc-magnifier"
            />
          </Grid>
          {/* <Grid cols="1 1 1 1">
            <Button
              onClick={() => this.props.handleSearchCnpjButton('nomeOrgao', this.props.stateDestinatario.ctcDestinacao.cnpj)}
              hint="Pesquisar cnpj do orgão destinatário"
              mini
              icon="ico-doc-magnifier"
            />
          </Grid> */}
          <Grid cols="8 8 8 8">
            <Input
              disabled={this.verificaSeCampoDesabilitado('nomeOrgao')}
              label="Nome do destinatário"
              maxLength="100"
              onChange={e => this.props.handleChange(e, 'nomeOrgao')}
              value={this.props.stateDestinatario.ctcDestinacao.nomeOrgao}
              touched={this.props.stateDestinatario.ctcDestinacao.touched}
              required
            />
          </Grid>
        </div>
        {this.props.stateDestinatario.tipoRegime === 2 &&
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled={this.verificaSeCampoDesabilitado('matricula')}
                label="Matrícula destino"
                maxLength="11"
                onChange={e => this.props.handleChange(e, 'matricula')}
                value={this.props.stateDestinatario.ctcDestinacao.matricula}
                integer
              />
            </Grid>
          </div>
        }
    </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.resetAtividades);
  }

  render() {
    return (
      <Modal
        {...this.props}
        backdrop="static"
        keyboard={false}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.props.handleCancelarAcao}
        size="lg"
        showModal={this.props.showModal}
        title={this.criarTituloModal()}
        hint={VAZIO}
      />
    );
  }
}

ModalDestinacao.propTypes = {
  destinacao: PropTypes.objectOf(PropTypes.object),
  showModal: PropTypes.func,
  statePrincipal: PropTypes.objectOf(PropTypes.object),
  stateDestinatario: PropTypes.objectOf(PropTypes.object),
  handleChange: PropTypes.func,
  handleManterDestinacao: PropTypes.func,
  handleSearchCnpjButton: PropTypes.func,
}.isRequired;

export default ModalDestinacao;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/ModalDestinacao.jsx